/*
 * @Description: Description
 * @Author: wning
 * @Date: 2022-11-30 18:11:26
 * @LastEditors: wning
 * @LastEditTime: 2022-11-30 18:22:59
 */

import XBack from './xBack.vue'

const xBack = {
  install(Vue) {
    Vue.component(XBack.name, XBack)
  }
}
export default xBack
